<template>
  <ds-section
    secondary
    fullheight
    centered>
    <ds-container size="large">
      <ds-space>
        <ds-logo inverse/>
      </ds-space>
      <ds-heading>Design system boilerplate<br>for Vue.js applications</ds-heading>
      <ds-text size="large">CION is a design system build primarily for Vue.js applications. You can use it as a starting point for building your own design system. The system utilizes design tokens, a living styleguide with integrated code playgrounds and reusable components for common UI tasks.</ds-text>
      <ds-space
        margin-top="x-large"
        margin-bottom="xxx-large">
        <ds-button
          path="https://styleguide.cion.visualjerk.de"
          icon="desktop">Styleguide demo</ds-button>&nbsp;
        <ds-button
          path="https://github.com/visualjerk/vue-cion-design-system"
          icon="github">GitHub</ds-button>
      </ds-space>
    </ds-container>
    <ds-space>
      <ds-flex
        :gutter="{ base: 'base', lg: 'xx-large' }"
        :width="{ base: '100%', md: 1 }">
        <ds-flex-item>
          <ds-card
            icon="book"
            primary
            centered
            hover>
            <ds-heading
              slot="header"
              tag="h3">
              Living<br>Styleguide
            </ds-heading>
            See the styleguide adapt to your design system as you move forward.
          </ds-card>
        </ds-flex-item>
        <ds-flex-item>
          <ds-card
            icon="file-code"
            primary
            centered
            hover>
            <ds-heading
              slot="header"
              tag="h3">
              Component<br>Documentation
            </ds-heading>
            Autogenerated documentation for your components with integrated playground.
          </ds-card>
        </ds-flex-item>
        <ds-flex-item>
          <ds-card
            icon="cubes"
            primary
            centered
            hover>
            <ds-heading
              slot="header"
              tag="h3">
              Basic<br>Components
            </ds-heading>
            Includes some basic components to help you get started.
          </ds-card>
        </ds-flex-item>
      </ds-flex>
    </ds-space>
  </ds-section>
</template>

<script>
export default {}
</script>
